var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.835 21.979-5.69-5.69a.56.56 0 0 0-.399-.165h-.619A9.72 9.72 0 0 0 19.5 9.75 9.75 9.75 0 0 0 9.749 0 9.75 9.75 0 0 0 0 9.75a9.75 9.75 0 0 0 9.75 9.749 9.72 9.72 0 0 0 6.374-2.372v.619c0 .15.061.29.164.398l5.69 5.69c.22.221.577.221.797 0l1.06-1.059a.563.563 0 0 0 0-.796M9.75 17.249a7.5 7.5 0 0 1-7.5-7.5c0-4.143 3.356-7.5 7.5-7.5 4.143 0 7.5 3.357 7.5 7.5 0 4.144-3.357 7.5-7.5 7.5"
  })));
};
export default SvgSearch;